export default __webpack_public_path__ + "assets/apple-touch-icon-120x120-de35986.png";